import React from 'react'
import {Link} from 'react-router-dom'
import  List from './List'
import AliceCarousel from 'react-alice-carousel';
import img1 from '../images/qus-bg-01.png'
import img2 from '../images/qus-bg-03.png'
import img3 from '../images/qus-bg-06.png'
import img4 from '../images/qus-bg-04.png'
import img5 from '../images/qus-bg-02.png'
import img6 from '../images/qus-bg-05.png'

const bgImages = {
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
}

const responsive = {
    0: {
        items: 1
    },
    320: {
        items: 1
    },
    650:{
        items: 2
    },
    767: {
        items: 3
    },
    1260: {
        items: 4
    },
    1460: {
        items: 5
    }
};
const responsivePopup = {
    0: {
        items: 1
    }
};
const imageList = [{
    id:'1',
    name:'project and task',
    image:''
},{
    id:'2',
    name:'inventory',
    image:''
},{
    id:'3',
    name:'mis',
    image:''
}]

class QuestionItemView extends React.Component{
    constructor(){
        super()
        this.state = {
            activeItem:'1'
        }
    }
    onClickhandler(item){
        this.setState({
            activeItem:item.id
        })
    }
    popupCloseHandler(e){
        this.props.closePopup()
    }
    render(){
        const {item} = this.props
        return  <div className={'question-container'}>
            <div className={'preview'}>
                <div className={'preview-content'}></div>
                <div className={'image-list'}>
                    {imageList.map(item=><li key={item.id} className={item.id === this.state.activeItem ? 'img-cls active' : 'img-cls'} onClick={this.onClickhandler.bind(this,item)}><div className={'logo'}>img</div><div className={'name'}>{item.name}</div></li>)}
                </div>
            </div>
            <div className={'details'}>
                <span className="close" onClick={this.popupCloseHandler.bind(this)}>&times;</span>
                <div className={'ans'}>
                    <div className={'title'}>Engineering {item.id}</div>
                    <div className={'qus'}>
                        How do I store and manage all my assets from a single place?
                    </div>
                    <p>Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cras mattis consectetur purus sit amet fermentum. Maecenas faucibus mollis interduma.</p>
                    <div className={'use'}>Using all three apps</div>
                    <p>Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cras mattis consectetur purus sit amet fermentum. Maecenas faucibus mollis interdum.</p>
                    <div className={'demo-btn'}>Request a Demo</div>
                </div>
                </div>
        </div>
    }
}

class PopupComponent extends React.Component{
    constructor(){
        super()
        this.state = {
            activeClass:false
        }
    }
    galleryItems(){
        const {data = []} = this.props
        return (
            data.map(function(item, i) {return <QuestionItemView closePopup={this.props.closePopup} id={item.id} key={item.id} onClick={this.onClickContent} item={item}/>},this)
        )

    }
    render(){
        return <div className={'popup-container'}>
            <div id="popup1" className={this.props.closeAnimation ? 'close-animation overlay' : 'overlay'}>
            </div>
            <div className={this.props.closeAnimation ? 'close-animation popup' : 'popup'}>
                <div className="content question-popup">
                    <AliceCarousel
                        items={this.galleryItems()}
                        duration={400}
                        fadeOutAnimation={true}
                        mouseDragEnabled={false}
                        autoPlay={false}
                        startIndex = {0}
                        playButtonEnabled={false}
                        autoPlayInterval={1000}
                        autoPlayDirection="ltr"
                    />                    </div>
            </div>
        </div>
    }
}

class ListItem extends React.Component {
    onClickHandler(){
        this.props.onClickContent()
    }
    render(){
        let itemData = this.props.itemData;
        return <li key={itemData.id} onClick={this.onClickHandler.bind(this)} className={itemData.className} ref={itemData.tag || ''}>{itemData.description}</li>
    }
}

export class SideScroll extends React.Component{
    constructor(){
        super()
        this.state = {
            activeItem:'leadership',
            activeClass:'leadership',
            autoPlay:true,
            showPopup:false,
            startIndex:0,
            navWidth:138,
            navHeight:34,
            left:0,
            closeAnimation:false
        }
        this.onClickContent = this.onClickContent.bind(this)
    }

    onClickContent(event){
        event.preventDefault()
     /*   document.body.classList.remove('close-open-cls');
        document.body.classList.add('popup-open-cls');
        this.setState({
            autoPlay:false,
            showPopup:true,
            closeAnimation:false
        })*/
    }
    domHandler(){
        let elements = document.getElementsByClassName('menu active');
        if(elements){
            elements[0].classList.remove('active');
        }
    }
    galleryItems(){
        const {data = []} = this.props
        return (
            data.map(function(item, i) {return <li ref={item.tag} className={item.className} id={item.id} key={item.id} style={{backgroundImage:`url(${bgImages[item.bgImage]})`}} onClick={this.onClickContent}>{item.description}</li>},this)
        )

    }
    onSlideChange(event){

    }
    onSlideChanged(event){
       const {data,width} = this.props;
        let activeItem = '';
        if(screen.width < 1025){
            activeItem = data[event.item]
        }else {
            activeItem = data[event.item+1]

        }
        if(event.item === data.length-1){
            activeItem = data[1]
        }
        const animationElements = document.getElementById(activeItem.className);
        this.animationHandler(activeItem.className,animationElements,activeItem)
    }
    animationHandler(activeClassName,offset,activeItem){
        this.domHandler()
        document.getElementById(activeClassName).classList.add("active");
        const animationElements = document.getElementById(activeClassName);
        const animateNav = document.getElementById('animate-nav');
        animateNav.style.left = `${offset.offsetLeft}px`;
        animateNav.style.width = `${offset.clientWidth}px`;
        animateNav.style.backgroundImage = `url(${bgImages[activeItem.bgImage]})`;
        this.slideContent.id = activeClassName
    }
    closePopup(){
        this.setState({
            closeAnimation:true
        });
        setTimeout(()=>{
            document.body.classList.remove('popup-open-cls');
            document.body.classList.add('close-open-cls');
            this.setState({
                showPopup:false,
                autoPlay:true
            })
        },650)
    }
    onMenuSelection(item,event){
        const {data} = this.props;
        const activeIndex = data.find(field=>field.className === item)
        this.setState({
            startIndex:Number(activeIndex.id)
        });
        this.animationHandler(item,event.target,activeIndex);
    }
    render(){
        const {data} = this.props
        console.log(this.state.activeItem)
        return <div className={'side-scroll-container'}>
           <div className={'nav-details'} data-aos="fade-up">
               <ul className={'menuList'} ref={menu => this.menuList = menu}>
                   <li className={this.state.activeClass === 'leadership' ? 'active menu' : 'menu'} id='leadership' onClick={this.onMenuSelection.bind(this,'leadership')}>Leadership</li>
                   <li className={this.state.activeClass  === 'sales' ? 'active menu' : 'menu'} id='sales' onClick={this.onMenuSelection.bind(this,'sales')}>Sales</li>
                   <li className={this.state.activeClass  === 'hr' ? 'active menu' : 'menu'} id='hr' onClick={this.onMenuSelection.bind(this,'hr')}>HR</li>
                   <li className={this.state.activeClass  === 'operations' ? 'active menu' : 'menu'} id='operations' onClick={this.onMenuSelection.bind(this,'operations')}>Business Operations</li>
                   <li className={this.state.activeClass  === 'finance' ? 'active menu' : 'menu'} id='finance' onClick={this.onMenuSelection.bind(this,'finance')}>Finance</li>
                   <li className={this.state.activeClass  === 'technology' ? 'active menu' : 'menu'} id='technology' onClick={this.onMenuSelection.bind(this,'technology')}>Technology</li>

                   <div className={'menu-animation'} id='animate-nav' style={{width:this.state.navWidth,height:this.state.navHeight,left:this.state.left}}></div>
               </ul>
           </div>

            <div className={'silder-content'}>
                <div className={'silder-content-sub'} data-aos="fade-up" ref={slide=>this.slideContent = slide} id={'leadership'}>
                    <AliceCarousel
                        items={this.galleryItems()}
                        duration={400}
                        responsive={responsive}
                        fadeOutAnimation={true}
                        mouseDragEnabled={false}
                        autoPlay={true}
                        startIndex = {this.state.startIndex}
                        playButtonEnabled={false}
                        autoPlayInterval={5000}
                        autoPlayDirection="ltr"
                        onSlideChange={this.onSlideChange.bind(this)}
                        onSlideChanged={this.onSlideChanged.bind(this)}
                    />
                </div>
{/*
                {this.state.showPopup ? <PopupComponent data={data} closePopup={this.closePopup.bind(this)} closeAnimation={this.state.closeAnimation}/> : ''}
*/}
            </div>

        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/SideScroll.js